'use strict';

import {Tabs, TabsContent, TabsList, TabsTrigger} from "../components/ui/Tabs";
import Loading from "../components/Loading";
import {
    getAircraftClasses,
    getAircraftsCompared,
    removeAircraftCompared,
    setAircraftClasses
} from "../helpers/aircraftCompare";
import useModalProps from "../hooks/useModalProps";

const TABS = {
    CLASSES: 'classes',
    MODELS: 'models',
}

function AircraftCompareModal(props) {
    const { tab } = useModalProps('reactAircraftCompareModal', props, { tab: TABS.CLASSES })
    
    const [ isFetching, setIsFetching ] = React.useState(false);
    const [ aircraftsCompared, setAircraftsCompared ] = React.useState([]);
    const [ activeTab, setActiveTab ] = React.useState(tab || TABS.CLASSES);
   
    React.useEffect(() => {
        listenEvent('react.openCompareAircraft', () => updateData())
    }, [])
    
    React.useEffect(() => {
        setActiveTab(tab);
    }, [ tab ])
    
    const fetchAircraftClasses = () => {
        setIsFetching(true);
        searchAction.fetchAircraftClasses().then(response => {
            setAircraftClasses(response.items || [])
            setIsFetching(false);
        });
    }
    
    const updateData = () => {
        const compared = [...getAircraftsCompared()];
        
        setAircraftsCompared(compared
            .sort((a, b) => parseInt(a.class.sort) - parseInt(b.class.sort)
                || parseFloat(a.params.volume_numeric) - parseFloat(b.params.volume_numeric)))
        
        if (getAircraftClasses().length > 0) return;
        fetchAircraftClasses()
    }

    const removeAircraftFromCompared = (id) => {
        removeAircraftCompared(id)
        updateData()
    }
    
    const aircraftClasses = getAircraftClasses();
        
    return <React.Fragment>
        
        <a href="#" className="el_compare-close" data-fancybox-close>{__('request.form.close')}</a>
        
        <Loading active={isFetching} absolute={false} />

        {!isFetching && aircraftClasses.length > 0 && <Tabs value={activeTab}>

            <div className="el_compare-top">
                <TabsList tag="ul" className="el_compare-tabs">
                    <li><TabsTrigger value={TABS.CLASSES}>{__('search.aircraft.classes')}</TabsTrigger></li>
                    <li><TabsTrigger value={TABS.MODELS}>{__('search.aircraft.models')}</TabsTrigger></li>
                </TabsList>
            </div>

            <TabsContent value={TABS.CLASSES} className="el-compare-toggle">
                <div className="el_compare-content">
                    <div className="el_compare-table">
                        <table>
                            <thead>
                            <tr>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.class.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.cabinDimensions.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.seats')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.cabinHeight.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.cabinWidth.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.cabinLength.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.baggageVolume.br')}}/>
                            </tr>
                            </thead>
                            <tbody>
                            {aircraftClasses.map(({
                                id,
                                title,
                                image,
                                sort,
                                params: {height, length, seats, trunk, width}
                            }) => {
                                return <tr key={`aircraftClasses${id}`}>
                                    <td>{title}</td>
                                    <td><img src={image} alt="" className='offer-compare__sheme'/></td>
                                    <td>{seats}</td>
                                    <td>{height}</td>
                                    <td>{width}</td>
                                    <td>{length}</td>
                                    <td dangerouslySetInnerHTML={{__html: trunk}}/>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </TabsContent>
            <TabsContent value={TABS.MODELS} className="el-compare-toggle">
                {aircraftsCompared.length > 0 && <div className="el_compare-content">
                    <div className="el_compare-table">
                        <table>
                            <thead>
                            <tr>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.model.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.class.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.cabinDimensions.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.seats')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.cabinHeight.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.cabinWidth.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.cabinLength.br')}}/>
                                <th dangerouslySetInnerHTML={{__html: __('search.aircraft.baggageVolume.br')}}/>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {aircraftsCompared.map(({
                                _version,
                                id,
                                title,
                                class: {title: titleClass, image},
                                params: {height, length, seats, trunk, width}
                            }) => {
                                if (_version === '3') {
                                    return <tr key={`aircraftsCompared${id}`}>
                                        <td>{title}</td>
                                        <td>{titleClass}</td>
                                        <td><img src={image.url} alt="" className='offer-compare__sheme'/></td>
                                        <td>{seats.value}</td>
                                        <td>{height.value} {height.units}</td>
                                        <td>{width.value} {width.units}</td>
                                        <td>{length.value} {length.units}</td>
                                        <td>{trunk.value} {trunk.units}</td>
                                        <td><a role='button' className="el_compare-remove" onClick={() => removeAircraftFromCompared(id)}></a></td>
                                    </tr>
                                    
                                } else {
                                    return <tr key={`aircraftsCompared${id}`}>
                                        <td>{title}</td>
                                        <td>{titleClass}</td>
                                        <td><img src={image} alt="" className='offer-compare__sheme'/></td>
                                        <td>{seats}</td>
                                        <td>{height}</td>
                                        <td>{width}</td>
                                        <td>{length}</td>
                                        <td>{trunk}</td>
                                        <td><a role='button' className="el_compare-remove" onClick={() => removeAircraftFromCompared(id)}></a></td>
                                    </tr>
                                }
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>}
                {aircraftsCompared.length === 0 && <div className="el-compare-bottom">
                    <div>
                        {__('search.compare.hintBefore')}
                        <span><i className="icon-compare2"></i> {__('search.card.compare')}</span>
                        {__('search.compare.hintAfter')}
                    </div>
                </div>}
            </TabsContent>
        </Tabs>}
        
    </React.Fragment>
}

const domContainer = document.querySelector('#reactAircraftCompareModal');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(AircraftCompareModal));
